// @ts-nocheck
import { Columns } from '../../../table/table.model';

export const tableHeader: Array<Columns> = [
  {
    name: 'id',
    type: 'data',
    label: 'Tipo de Solicitação',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'financialCode',
    type: 'data',
    label: 'Linha Digitável',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'reference_date',
    type: 'data',
    label: 'Data de Referência',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'payValue',
    type: 'data',
    label: 'Valor',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'payValueUS',
    type: 'data',
    label: 'Valor em Dólar',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'updated_value',
    type: 'data',
    label: 'Valor Atualizado',
    col: 3,
    enableCopy: false,
  },
];
